/**
 * NAVIGATION.JS
 *
 * Initialization and control for the header menu on desktop and mobile.
 */

import * as GLOBALS from '../globals';
import HighlightedNavigation from './navigation-highlight';
import AlertNotice from './alert-notice';
import Toggle from '../classes/toggle';
import Slideable from '../classes/slideable';

export default class HeaderMenu {

	static init() {
		return new HeaderMenu();
	}

	constructor() {
		const headermenu = document.querySelector('.headermenu');

		if (headermenu === null)
			return;
	
		AlertNotice.init();
	
		const navigationList = headermenu.querySelector('.headermenu-items');
	
		if (navigationList === null || navigationList.childElementCount === 0)
			return;
	
		this.initHamburgerMenu(headermenu);
	
		if (GLOBALS.ENABLE_DROPDOWN_MENU) {
			this.initDropdownMenu(headermenu);
		}
	
		if (GLOBALS.ENABLE_HIGHLIGHTED_NAVIGATION) {
			HighlightedNavigation.init(navigationList);
		}
	
		if (GLOBALS.ENABLE_TRANSPARENT_HEADER) {
			this.initTransparentHeader(headermenu);
		}

		window.addEventListener('resize', this.recalculateViewHeight);
	
		return true;
	}

	/**
	 * Initializes the mobile hamburger menu button to toggle between open/closed.
	 *
	 * @return {boolean} successful?
	 */
	initHamburgerMenu(headermenu) {
		const element = headermenu.querySelector('button.hamburger');
		const navigationElements = headermenu.querySelectorAll('.nav-item');

		if (element === null)
			return;

		this.recalculateViewHeight();

		const slideableNavigationList = new Slideable(headermenu.querySelector('.headermenu-items'), 300, 'flex');
		
		new Toggle(element, () => {
			slideableNavigationList.toggle();
			document.body.classList.toggle('modal-opened');
		});

		window.addEventListener('closeHeadermenu', () => {
			if(window.getComputedStyle(element).display === 'block') element.click();
		});

		if (navigationElements !== null) {
			navigationElements.forEach((navItem) => {
				const link = navItem.querySelector('a');
				if(!link)
					return;
				link.addEventListener('click', () => {
					if(window.getComputedStyle(element).display === 'block') element.click();
				});
			});
		}
	}

	/**
	 * Initializes the mobile dropdown menu buttons to toggle between open/closed.
	 *
	 * @return {boolean} successful?
	 */
	initDropdownMenu(headermenu) {
		const elements = headermenu.querySelectorAll('.nav-item.has-children');
		const burgermenu = headermenu.querySelector('button.hamburger');

		if (elements.length === 0)
			return;

		elements.forEach((navItem) => {
			const dropDownItems = navItem.querySelectorAll('.nav-dropdown-item');

			dropDownItems.forEach((item) => {
				const link = item.querySelector('a');
				link.addEventListener('click', () => {
					if(window.getComputedStyle(burgermenu).display === 'block') burgermenu.click();
				});
			});

			var dropdown = new Slideable(navItem.querySelector('.nav-dropdown'));
			new Toggle(navItem.querySelector('button'), () => {
				dropdown.toggle();
			});
		});
	}

	/**
	 * Initializes the functionality for the header menu to be transparent at the top of the page and get opaque once the user scrolled down a bit
	 *
	 * @param {Element} headermenu
	 */
	initTransparentHeader(headermenu) {
		if (window.innerWidth < GLOBALS.BREAKPOINT_XL || document.querySelectorAll('.error-page').length > 0)
			return;

		const changeBasedOnScrollOffset = () => {
			let scrollTop = document.documentElement.scrollTop;
			const desktopHeader = headermenu.querySelector('.headermenu-items');
			const logo = desktopHeader.querySelector('.logo');
			const logoAlt = desktopHeader.querySelector('.logo-alt');

			if (Math.abs(scrollTop - window.innerHeight * 0.5) > headermenu.clientHeight) {
				if(scrollTop > window.innerHeight * 0.5) {
					headermenu.classList.remove('headermenu-transparent');
					if (logoAlt) {
						logo.classList.remove('opacity-0');
						logoAlt.classList.add('opacity-0');
					}
				} else {
					headermenu.classList.add('headermenu-transparent');
					if (logoAlt) {
						logo.classList.add('opacity-0');
						logoAlt.classList.remove('opacity-0');
					}
				}
			}
		};

		window.addEventListener('scroll', changeBasedOnScrollOffset);

		changeBasedOnScrollOffset();
	}

	recalculateViewHeight() {
		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	}
}